import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export const theme = {
  options: { customProperties: true },
  themes: {
    light: {
      primary: '#459D42', // #E53935
      success: '#459D42',
      red: '#c33',
      krungsri: '#FFE000',
      kbank: '#0E8F34',
      scb: '#4F2A80',
      twoCTwoP: '#1B99C8',
      // secondary: colors.red.lighten4, // #FFCDD2
      // accent: colors.indigo.base, // #3F51B5
    },
  },
}
export default new Vuetify({
  theme,
})
